import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { ExistingDocumentsWithNumberQuery, ExistingDocumentsWithNumberQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ExistingDocumentsWithNumberQuery)
@Wrapper(ExistingDocumentsWithNumberQueryHandlerBase)
export class ExistingDocumentsWithNumberQueryHandler {
    public constructor(
        http: Http
    ) { }
}
